import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../../environments/environment';
import { RequestTokenService } from '../../../../../../services/request-token.service';

const API_URL = `${environment.apiUrl}v10/Usuario`;

@Injectable({
  providedIn: 'root',
})
export class UsuarioService {
  constructor(
    private http: HttpClient,
    private requestToken: RequestTokenService,
  ) {}

  private handleError(error: any): Observable<never> {
    console.error('An error occurred', error);
    return throwError(error);
  }

  CarregaDataUltimoFechamentoExecutivo(): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true,
    };

    return this.http
      .get<any>(`${API_URL}/CarregaDataUltimoFechamentoExecutivo`, options)
      .pipe(catchError(this.handleError));
  }
}
